import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAuthContext } from '../../../context/AuthContext';
import styles from './TeamSection.module.scss';

export const TeamSection: React.FC = () => {
    const { t } = useTranslation();
    const { user, isAuthenticated } = useAuthContext();

    const isProfessional = isAuthenticated && user?.type_account === 'professional';
    const isConsultant = isAuthenticated && user?.type_account === 'patient';

    return (
        <section className={styles['team-section']} id="equipo">
            <div className={styles['team-section__card']}>
                <p className={styles['team-section__eyebrow']}>
                    {t('landing.team.eyebrow', 'SINERGIA')}
                </p>

                <h2 className={styles['team-section__title']} data-no-animate>
                    <span className={styles['team-section__title-line']}>
                        {t('landing.team.title1', '¿Te gustaría ser parte')}
                    </span>
                    <span className={styles['team-section__title-line']}>
                        {t('landing.team.title2', 'del equipo?')}
                    </span>
                </h2>

                <p className={styles['team-section__copy']}>
                    {t('landing.team.description', 'Sumate a una comunidad de profesionales que comparten una mirada humana e integrativa de la salud. Un espacio para encontrarse con colegas, intercambiar saberes y formar parte de una red que busca acompañar a las personas de una manera más amplia, consciente y colaborativa.')}
                </p>

                <div className={styles['team-section__action']}>
                    <Link to="/profesionales-landing" className={styles['team-section__btn']}>
                        {t('landing.team.cta', 'Quiero ser parte del equipo')}
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default TeamSection;